import { z } from 'zod';
import { CONTROLLER_TYPES, MACHINE_STATUSES } from '../constants/enums.js';

export const telemetrySchema = z.object({
  machine_id: z.string().min(1).max(64),
  shop_id: z.string().min(1).max(64),
  controller_type: z.enum(CONTROLLER_TYPES),
  status: z.enum(MACHINE_STATUSES),
  spindle_rpm: z.number().finite().min(0).max(100_000),
  feed_rate: z.number().finite().min(0).max(50_000),
  program_name: z.string().max(256),
  alarm_code: z.string().max(64).nullable(),
  oee_percent: z.number().finite().min(0).max(100),
  cycle_time_seconds: z.number().finite().min(0),
  timestamp: z.string().datetime({ offset: true }),
});

export type Telemetry = z.infer<typeof telemetrySchema>;
